import React from 'react';
import ProfilePage from './ProfilePage';

// Dedicated read-only "View profile" page wrapper.
// Uses the same ProfilePage display logic but forces read-only UI.
const ProfileViewPage = () => {
  return <ProfilePage forcedReadOnly />;
};

export default ProfileViewPage;

